import { Box, Flex, Text } from "@chakra-ui/react";

import { arrowRight } from "../../../../assets";

import { BlockCard } from "../style";

// import CustomScroll from "react-custom-scroll";

export const Block = ({ id, sidebar, children }) => {
  return (
    <Box pb={"96px"} key={id}>
      {/* Main Card Content */}
      <BlockCard
        mb={"40px"}
        flexDir={{ base: "column", md: "column", lg: "row" }}
      >
        {/* LEFT SIDEBOX */}
        <Flex
          flexDir={{ base: "row", md: "row", lg: "column" }}
          // justifyContent={{ md: "space-between", lg: "flex-start" }}
          flexWrap="wrap"
          minWidth={{ base: "100%", md: "100%", lg: "185px" }}
          maxWidth={{ base: "100%", md: "100%", lg: "185px" }}
          className="left"
          mt={{ lg: "18px" }}
        >
          {/* Side Content Details */}
          {sidebar
            ? sidebar.map((val) => {
                return (
                  <Box
                    maxW={["170px"]}
                    // mb={"43px"}
                    mr={{ base: "36px", md: "36px", lg: "none" }}
                    mb={{ base: "16px", md: "16px", lg: "44px" }}
                  >
                    <Box
                      display="flex"
                      pl={["7px"]}
                      mb={{ base: "4px", md: "4px", lg: "6px" }}
                      width={{ base: "115px", md: "170px", lg: "null" }}
                    >
                      <img src={arrowRight} alt="indicator" />
                      <Text
                        fontSize={{ base: "15px", md: "16px", lg: "18px" }}
                        lineHeight={["24px"]}
                        ml="11px"
                        className="name"
                      >
                        {val}
                      </Text>
                    </Box>
                    <hr />
                  </Box>
                );
              })
            : ""}
        </Flex>

        {/* RIGHT SIDEBOX */}
        <Box
          borderLeft={{ base: "none", md: "none", lg: "1px solid #000" }}
          width={{ base: "100%", md: "100%", lg: "1038px" }}
          pl={{ base: 0, md: 0, lg: "20px" }}
        >
          {children}
        </Box>
      </BlockCard>
      <hr style={{ background: "#131215", height: "1px" }} />
    </Box>
  );
};
